package co.torvus.web

import kotlinx.browser.window
import org.w3c.dom.Element

/**
 * Animates [container]'s vertical scroll to [targetTop] via requestAnimationFrame.
 * Done manually (instant per-frame sets) because native `scroll-behavior: smooth`
 * gets cancelled by the scroll-spy re-renders that fire during the animation.
 */
fun smoothScrollTo(
    container: Element,
    targetTop: Double,
    durationMs: Double = 480.0,
    onDone: () -> Unit = {},
) {
    val startTop = container.scrollTop
    val distance = targetTop - startTop
    if (distance == 0.0) {
        onDone()
        return
    }

    var startTime = -1.0
    fun step(timestamp: Double) {
        if (startTime < 0.0) startTime = timestamp
        val progress = ((timestamp - startTime) / durationMs).coerceIn(0.0, 1.0)
        val eased = 1.0 - (1.0 - progress) * (1.0 - progress) * (1.0 - progress) // easeOutCubic
        container.scrollTop = startTop + distance * eased
        if (progress < 1.0) {
            window.requestAnimationFrame(::step)
        } else {
            onDone()
        }
    }
    window.requestAnimationFrame(::step)
}
